import { render, staticRenderFns } from "./MemberWinloseDetail.vue?vue&type=template&id=5ed318ee&"
import script from "./MemberWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./MemberWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports